import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/aeros_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-debfe21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "sidebar-logo",
  alt: "logo"
}, null, -1))
const _hoisted_3 = { class: "links" }
const _hoisted_4 = { class: "user" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "link",
          key: route
        }, [
          (route.meta.label)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                style: _normalizeStyle({'color': _ctx.settingsStore.colorScheme === 'dark' ? '#E6EAF6' : '#004AAD'}),
                class: "router-link",
                "active-class": "active",
                to: route.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(route.meta.label)) + " ", 1),
                  (route.name === 'notifications' && _ctx.notificationsStore.getUnread > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "badge",
                        style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#000000' : '#FFFFFF',
                'border': _ctx.settingsStore.colorScheme === 'dark' ? '2px solid rgba(0, 0, 0, 0.8)' : '2px solid transparent'
              })
                      }, _toDisplayString(`${_ctx.notificationsStore.getUnread}+`), 5))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["style", "to"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", {
        style: _normalizeStyle({fontSize: `${12 + (_ctx.user?.preferred_username.length - 23)}px`}),
        class: "username"
      }, _toDisplayString(_ctx.user?.preferred_username), 5),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          style: _normalizeStyle({'color': _ctx.settingsStore.colorScheme === 'dark' ? '#E6EAF6' : '#004AAD'}),
          class: "router-link",
          "active-class": "active",
          to: "/settings"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('settings.settings')), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "logout",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
        }, [
          _createTextVNode(" Logout "),
          _createVNode(_component_font_awesome_icon, { icon: "arrow-right-from-bracket" })
        ])
      ])
    ])
  ]))
}